import { GET_STORE_DETAIL } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_STORE_DETAIL:
            return action.payload;
        default:
            return state;
    }
}